// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-page-2-js": () => import("./../../../src/pages/page-2.js" /* webpackChunkName: "component---src-pages-page-2-js" */),
  "component---src-pages-using-typescript-tsx": () => import("./../../../src/pages/using-typescript.tsx" /* webpackChunkName: "component---src-pages-using-typescript-tsx" */),
  "component---src-templates-wp-page-template-js": () => import("./../../../src/templates/wp-page-template.js" /* webpackChunkName: "component---src-templates-wp-page-template-js" */),
  "component---src-templates-wp-post-template-js": () => import("./../../../src/templates/wp-post-template.js" /* webpackChunkName: "component---src-templates-wp-post-template-js" */)
}

